import { defineStore } from 'pinia'
import { authService } from '@/services/auth.service'
import { organizationService } from '@/services/organization.service'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: JSON.parse(localStorage.getItem('user') || 'null'),
    token: localStorage.getItem('token') || null,
    isAuthenticated: false,
    permissions: []
  }),

  getters: {
    isLoggedIn: (state) => !!state.token && !!state.user,
    userPermissions: (state) => state.permissions,
    hasPermission: (state) => (permission) => {
      if (Array.isArray(permission)) {
        return permission.some(perm => state.permissions.some(p => p.slug === perm))
      }
      return state.permissions.some(p => p.slug === permission)
    },
    userName: (state) => state.user?.name || '',
    userEmail: (state) => state.user?.email || '',
    currentOrganizationId: (state) => state.user?.organization_current_id ?? null,
    currentOrganizationName: (state) => {
      const organizations = state.user?.organizations || []
      const current = organizations.find(org => org.id === state.user?.organization_current_id)
      return current?.name || ''
    },
    currentOrganizationPackageName: (state) => {
      const organizations = state.user?.organizations || []
      const current = organizations.find(org => org.id === state.user?.organization_current_id)
      return current?.package_name || ''
    }
  },

  actions: {
    async login(credentials) {
      try {
        const response = await authService.login(credentials)
        this.applyAuthResponse(response)
        return response
      } catch (error) {
        this.logout()
        throw error
      }
    },

    async loginWithGoogle(code) {
      try {
        const response = await authService.loginWithGoogle(code)
        this.applyAuthResponse(response)
        return response
      } catch (error) {
        this.logout()
        throw error
      }
    },

    applyAuthResponse(response) {
      this.token = response.token
      this.user = response.user
      this.permissions = response.user.permissions || []
      this.isAuthenticated = true

      localStorage.setItem('token', this.token)
      localStorage.setItem('user', JSON.stringify(this.user))
      if (response.refresh_token) {
        localStorage.setItem('refresh_token', response.refresh_token)
      }
    },

    async logout() {
      try {
        await authService.logout()
      } catch (error) {
        console.error('Logout API error:', error)
      } finally {
        this.token = null
        this.user = null
        this.permissions = []
        this.isAuthenticated = false

        localStorage.removeItem('token')
        localStorage.removeItem('user')
        localStorage.removeItem('refresh_token')
      }
    },

    async selectOrganization(orgId) {
      const response = await organizationService.selectOrganization(orgId)
      this.user = response.data.user
      localStorage.setItem('user', JSON.stringify(this.user))
      return response
    },

    initializeAuth() {
      const token = localStorage.getItem('token')
      const user = localStorage.getItem('user')
      
      if (token && user) {
        try {
          this.token = token
          this.user = JSON.parse(user)
          this.permissions = this.user.permissions || []
          this.isAuthenticated = true
        } catch (error) {
          console.error('Failed to parse user data:', error)
          //this.logout()
        }
      }
    },

    async refreshUserData() {
      try {
        const response = await authService.getCurrentUser()
        this.user = response.user
        this.permissions = response.user.permissions || []
        localStorage.setItem('user', JSON.stringify(this.user))
      } catch (error) {
        console.error('Failed to refresh user data:', error)
        //this.logout()
      }
    }
  }
})
